export const SET_USER_ONLINE_STATUS = "SET_USER_ONLINE_STATUS";

export const setUserOnlineStatus = (userId, isOnline) => ({
  type: SET_USER_ONLINE_STATUS,
  payload: { userId, isOnline }
});
